var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ForgotButton_Container"},[_c('button',{staticClass:"ForgotButton_Btn",on:{"click":function($event){return _vm.$emit('forgotPassword')}}},[_vm._v(" Forget password ? ")])])}
var staticRenderFns = []

export { render, staticRenderFns }